<template>
    <div class="row" style="text-align: center; width: 100%; height: 100%;position: absolute; z-index: 5999; background-color: #fff">
        <div class="col self-center">
            <div style="background-image: url(/assets/images/icon/img_study_intro_green.png);width: 50%;height: 50vh; background-position-x: center;background-repeat: no-repeat;background-size: contain; display: inline-grid;justify-content: center" :style="props.title === '드릴문제' ? 'background-image: url(/assets/images/icon/img_drill_intro.png);' : ''">
            </div>
            <!-- <img src="/assets/images/symbols/splash.png" alt="splash" /> -->
            <div class="text-h5" style="font-size: 3.83vmin; margin-bottom: 5vmin">
                <b>{{ props.title }}</b>
            </div>
            <q-spinner size="7.66vmin" style="color:#18b73f" />
        </div>
    </div>
</template>

<script setup>
import { soundEffect } from '@/helpers/soundEffect';
import { defineProps, onMounted } from 'vue';

const props = defineProps([
    'title'
])

onMounted(() => {
    // soundEnter();
    soundEffect('enter');
})
</script>

<style scoped lang="scss"></style>
